import React from 'react';

interface TaskTypesProps {
    fill?: string;
}

export const TaskTypes = ({ fill }: TaskTypesProps) => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2224_15699)">
                <path d="M11.9999 2H3.5V2.99998H11.9999V2Z" fill="#374957" />
                <path d="M11.9999 5.5H3.5V6.49999H11.9999V5.5Z" fill="#374957" />
                <path d="M11.9999 9H3.5V9.99999H11.9999V9Z" fill="#374957" />
                <path
                    d="M0.999987 3.49997C1.55226 3.49997 1.99997 3.05226 1.99997 2.49998C1.99997 1.94771 1.55226 1.5 0.999987 1.5C0.447709 1.5 0 1.94771 0 2.49998C0 3.05226 0.447709 3.49997 0.999987 3.49997Z"
                    fill="#374957"
                />
                <path
                    d="M0.999987 6.99997C1.55226 6.99997 1.99997 6.55226 1.99997 5.99998C1.99997 5.44771 1.55226 5 0.999987 5C0.447709 5 0 5.44771 0 5.99998C0 6.55226 0.447709 6.99997 0.999987 6.99997Z"
                    fill="#374957"
                />
                <path
                    d="M0.999987 10.5C1.55226 10.5 1.99997 10.0523 1.99997 9.49998C1.99997 8.94771 1.55226 8.5 0.999987 8.5C0.447709 8.5 0 8.94771 0 9.49998C0 10.0523 0.447709 10.5 0.999987 10.5Z"
                    fill="#374957"
                />
            </g>
            <defs>
                <clipPath id="clip0_2224_15699">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
